let cart = {};
let giftMappings = {};

async function loadCart() {
  try {
    const res = await window.fetch('/cart.js'); // explicitly use window.fetch to avoid intercept loops if any
    if (!res.ok) throw new Error('Failed to load cart');
    return await res.json();
  } catch (error) {
    console.error('Error loading cart:', error);
    return { items: [] }; // Return empty cart structure on error
  }
}

// Global Interceptors for Add to Cart
(function() {
  const originalXHRSend = XMLHttpRequest.prototype.send;
  const originalXHROpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function(method, url) {
    if (typeof url === 'string') {
      this._subscriptionRequestUrl = url;
    }
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    this.addEventListener('load', function() {
      if (this._subscriptionRequestUrl && (this._subscriptionRequestUrl.includes('/cart/add.js') || this._subscriptionRequestUrl.includes('/cart/add'))) {
        try {
          if (this.status >= 200 && this.status < 300) {
            const data = JSON.parse(this.responseText);
            const items = data.items || [data];
            items.forEach(item => {
              if (item.variant_id || item.id) {
                // Slightly delay to allow theme scripts to finish their cart logic
                setTimeout(() => {
                  checkAutoAddMapping(item.variant_id || item.id, item);
                }, 100);
              }
            });
          }
        } catch (e) {
          console.error("Error intercepting XHR cart/add:", e);
        }
      }
    });
    return originalXHRSend.apply(this, arguments);
  };

  const originalFetch = window.fetch;
  window.fetch = async function() {
    const url = arguments[0];
    const response = await originalFetch.apply(this, arguments);
    
    // Only intercept successful cart add responses
    if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/add'))) {
      try {
        const clone = response.clone();
        if (clone.ok) {
          const data = await clone.json();
          const items = data.items || [data];
          items.forEach(item => {
            if (item.variant_id || item.id) {
              setTimeout(() => {
                checkAutoAddMapping(item.variant_id || item.id, item);
              }, 100);
            }
          });
        }
      } catch (e) {
        // Ignore JSON parsing errors for non-JSON responses
      }
    }
    return response;
  };
})();

document.addEventListener("DOMContentLoaded", async () => {
  cart = await loadCart();
  console.log("Cart loaded:", cart);

  const giftMappingsScript = document.getElementById("gift-mappings-data");

  if (giftMappingsScript) {
    try {
      giftMappings = JSON.parse(giftMappingsScript.textContent);
      console.log("Loaded Metaobject gift mappings:", giftMappings);
    } catch (err) {
      console.error("Failed to parse gift mappings JSON:", err);
    }
  }
});


  
  // Function to add products to cart in the new theme
  function addGift(variantId, quantity, customProperties = {}, key) {
    let formData = {
      items: [{
        id: variantId,
        quantity: quantity,
        properties: customProperties
      }]
    };
  
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status !== 200) {
        console.error('Cart update error:', data.description || data.message);
        return;
      }
      var cartDrawer = new theme.CartDrawer();
      cart = loadCart();
      return data;
      
    })
    .catch(error => {
      console.error('Error adding item to cart:', error);
    });
  }

  async function checkAutoAddMapping(triggerVariantId, productInfo) {
    const mapping = giftMappings[triggerVariantId];
    if (!mapping) return;

    // Get the main product's title and key from the cart
    const productTitle = productInfo ? (productInfo.product_title || productInfo.title) : 'Product';
    const productKey = productInfo ? productInfo.key : `item_${Date.now()}`;

    const giftMessagePrefix = `Free gift for subscribing ${productTitle}`;

    // ✅ Fetch cart and check if any gifts are already present for this trigger
    try {
      // Reload cart to get fresh data
      cart = await loadCart();
      let giftAlreadyInCart = false;

      for (const item of cart.items) {
        const props = item.properties || {};
        if (
          props._autoGiftFor &&
          props._autoGiftFor.toString() === triggerVariantId.toString()
        ) {
          giftAlreadyInCart = true;
          break;
        }
      }

      if (giftAlreadyInCart) {
        console.log(`Gift already exists for ${productTitle} (${triggerVariantId}), skipping gift add`);
        return;
      }

      // Continue with auto gift logic
      if (mapping.rule === "and") {
        mapping.products.forEach((prod) => {
          const giftMessage = `${giftMessagePrefix}`;
          const myProperties = {
            _autoGiftFor: triggerVariantId,
            _forProductKey: productKey,
            _isGift: "gift",
            GiftMessage: giftMessage
          };
          console.log(`Auto adding (AND) variant ${prod.targetVariantId} with quantity ${prod.quantity} for product ${productTitle}`);
          addGift(prod.targetVariantId, prod.quantity, myProperties);
        });
      } else if (mapping.rule === "or") {
        console.time("Opening Modal");
        showAutoAddChoiceModal(mapping.products, triggerVariantId, productKey, productTitle, giftMessagePrefix);
      } else {
        console.warn(`Unknown auto-add rule for trigger ${triggerVariantId}`);
      }
    } catch (err) {
      console.error('Failed to check if gift already exists in cart:', err);
    }
  }
  
  // Function to show modal for selecting gift options
  function showAutoAddChoiceModal(products, triggerVariantId, productKey, productTitle, giftMessagePrefix) {
    console.timeEnd("Opening Modal");
    console.time("Render Modal");
    const overlay = document.getElementById('gift-choice-overlay');
    const optionsContainer = document.getElementById('gift-choice-options');
    const closeBtn = document.getElementById('gift-choice-close');
  
    optionsContainer.innerHTML = '';
  
    products.forEach(async (prod) => {
      const image_url = prod.img;
      const card = document.createElement('div');
      card.className = 'gift-choice-card';
      
      const cardcontent = document.createElement('div');
      cardcontent.className = 'gift-choice-card-content';
  
      const img = document.createElement('img');
      img.src = image_url || 'https://via.placeholder.com/64';
      img.alt = prod.displayText;
  
      const info = document.createElement('div');
      info.className = 'gift-info';
  
      const title = document.createElement('div');
      title.className = 'gift-title';
      title.textContent = prod.displayText;
  
      const addBtn = document.createElement('button');
      addBtn.textContent = 'Add Gift';
      addBtn.addEventListener('click', () => {
        const giftMessage = `${giftMessagePrefix}`;
        const myProperties = {
          _autoGiftFor: triggerVariantId,
          _forProductKey: productKey,
          _isGift: "gift",
          GiftMessage: giftMessage
        };
        addGift(prod.targetVariantId, prod.quantity, myProperties, productKey);
        overlay.classList.add('hidden');
      });
  
      info.appendChild(title);
      cardcontent.appendChild(info);
      cardcontent.appendChild(addBtn);
      card.appendChild(img);
      card.appendChild(cardcontent);
      optionsContainer.appendChild(card);
    });
  
    closeBtn.addEventListener('click', () => {
      overlay.classList.add('hidden');
    });
  
    overlay.classList.remove('hidden');
    console.timeEnd("Render Modal");
  }
  
  // Function to remove orphaned gift items
  function removeOrphanGiftItemsOld() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Create maps to track relationships between main products and gifts
        const mainProductKeys = new Set(); // Track all product keys in cart
        const mainProductVariants = new Set(); // Track all variant IDs in cart
        const giftItems = []; // Array of gift items to check
        
        // First pass: catalog all items in the cart
        cart.items.forEach((item, index) => {
          const properties = item.properties || {};
          
          if (properties._autoGiftFor) {
            // This is a gift item
            giftItems.push({
              index,
              key: item.key,
              forVariantId: properties._autoGiftFor,
              forProductKey: properties._forProductKey || null
            });
          } else {
            // This is a main product
            mainProductKeys.add(item.key);
            mainProductVariants.add(item.variant_id.toString());
          }
        });
        
        console.log("Main products in cart (keys):", [...mainProductKeys]);
        console.log("Main products in cart (variants):", [...mainProductVariants]);
        console.log("Gift items to check:", giftItems);
        
        // Second pass: identify orphaned gifts with precise tracking
        const updates = {};
        let orphansFound = false;
        
        giftItems.forEach(gift => {
          let isOrphaned = false;
          
          // Check if the gift is orphaned based on its relationship type
          if (gift.forProductKey) {
            // If the gift is linked to a specific product key, check if that key exists
            if (!mainProductKeys.has(gift.forProductKey)) {
              console.log(`Gift ${gift.key} is orphaned - specific product key ${gift.forProductKey} not found`);
              isOrphaned = true;
            }
          } else if (gift.forVariantId) {
            // If the gift is only linked to a variant ID, check if that variant exists
            if (!mainProductVariants.has(gift.forVariantId)) {
              console.log(`Gift ${gift.key} is orphaned - no variant ${gift.forVariantId} in cart`);
              isOrphaned = true;
            }
          }
          
          if (isOrphaned) {
            updates[gift.key] = 0; // Remove the orphaned gift
            orphansFound = true;
          }
        });
  
        // If there are any orphans to remove, update the cart
        if (orphansFound) {
          console.log("Updating cart to remove orphans:", updates);
          
          fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(data => {
            // Update the cart UI
            var cartDrawer = new theme.CartDrawer();
           // cart.init();
           // cart.open();
          })
          .catch(error => {
            console.error('Error updating cart:', error);
          });
        }
      })
      .catch(error => {
        console.error('Error fetching cart for orphan gift removal:', error);
      });
  }

  function removeOrphanGiftItemsExp() {
    // Use the already loaded cart data when possible
    return Promise.resolve(cart.items ? cart : loadCart())
      .then(currentCart => {
        const mainProductKeys = new Set();
        const mainProductVariants = new Set();
        const giftItems = [];
        const updates = {};
        
        // Process cart items in a single pass if possible
        currentCart.items.forEach(item => {
          const properties = item.properties || {};
          
          if (properties._autoGiftFor) {
            giftItems.push({
              key: item.key,
              forVariantId: properties._autoGiftFor,
              forProductKey: properties._forProductKey || null
            });
          } else {
            mainProductKeys.add(item.key);
            mainProductVariants.add(item.variant_id.toString());
          }
        });
        
        // Check for orphans
        let orphansFound = false;
        giftItems.forEach(gift => {
          const isOrphaned = (gift.forProductKey && !mainProductKeys.has(gift.forProductKey)) || 
                            (gift.forVariantId && !mainProductVariants.has(gift.forVariantId));
          
          if (isOrphaned) {
            updates[gift.key] = 0;
            orphansFound = true;
          }
        });
        
        if (!orphansFound) return currentCart;
        
        // Only update if orphans found
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(updatedCart => {
          cart = updatedCart; // Update local cart reference
          var cartDrawer = new theme.CartDrawer();
          return updatedCart;
        });
      });
  }

  function removeOrphanGiftItems() {
    // Use a debounce to prevent multiple rapid calls
    if (removeOrphanGiftItems.timeout) {
      clearTimeout(removeOrphanGiftItems.timeout);
    }
    
    removeOrphanGiftItems.timeout = setTimeout(() => {
      console.time("orphanRemoval");
      
      // ALWAYS fetch the latest cart to avoid using a stale cache when items are removed by the theme
      loadCart()
        .then(currentCart => {
          cart = currentCart; // Update global cache with fresh data
          // Use Maps for O(1) lookups instead of Sets
          const mainProductKeys = new Map();
          const mainProductVariants = new Map();
          const giftItems = [];
          const updates = {};
          
          // Process cart items in a single pass
          currentCart.items.forEach(item => {
            const properties = item.properties || {};
            
            if (properties._autoGiftFor) {
              // This is a gift item
              giftItems.push({
                key: item.key,
                forVariantId: properties._autoGiftFor,
                forProductKey: properties._forProductKey || null
              });
            } else {
              // This is a main product - store with O(1) lookup
              if (item.key) mainProductKeys.set(item.key, true);
              if (item.variant_id) mainProductVariants.set(item.variant_id.toString(), true);
            }
          });
          
          // Fast orphan check with Map lookups (O(1) instead of O(n))
          let orphansFound = false;
          
          giftItems.forEach(gift => {
            // A gift is orphaned only if its triggering main product variant is completely gone from the cart
            const isOrphaned = !mainProductVariants.has(gift.forVariantId.toString());
            
            if (isOrphaned) {
              updates[gift.key] = 0;
              orphansFound = true;
            }
          });
          
          // Only update if orphans found
          if (!orphansFound) {
            console.log("No orphaned gifts found, skipping update");
            console.timeEnd("orphanRemoval");
            return currentCart;
          }
          
          console.log("Removing orphaned gifts:", updates);
          
          // Only update if orphans found
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ updates })
          })
          .then(response => response.json())
          .then(updatedCart => {
            cart = updatedCart; // Update local cart reference
            
            // Immediately dispatch cart:build so the theme refreshes the cart drawer UI
            document.dispatchEvent(new CustomEvent('cart:build'));
            
            console.timeEnd("orphanRemoval");
            return updatedCart;
          });
        })
        .catch(error => {
          console.error("Error in orphan removal:", error);
          console.timeEnd("orphanRemoval");
        });
    }, 50); // Fast debounce so removal is perceived as immediate
  }
  
  // Restore original form submit handler (but let global interceptors handle the gift checking)
  document.addEventListener('DOMContentLoaded', function() {
    document.body.addEventListener('submit', function(event) {
      if (event.target.action && event.target.action.includes('/cart/add')) {
        console.log("Adding to cart from Subscription app.");
        event.preventDefault();
    
        const formData = new FormData(event.target);
        const variantId = formData.get('id');
        const quantity = formData.get('quantity') || 1;
    
        const hasGiftAttached = !!giftMappings[variantId];
        
        let productData = {
          items: [{
            id: variantId,
            quantity: quantity,
            ...(hasGiftAttached && {
              properties: {
                _isGift: "source"
              }
            })
          }]
        };
    
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(productData)
        })
        .then(response => response.json())
        .then(data => {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              variantId,
              quantity,
              response: data
            }
          }));
          
          console.log("Product added via form override response is : ", data);
          // checkAutoAddMapping is omitted here because the global fetch interceptor at the top of the file 
          // will catch this successful fetch('/cart/add.js') and trigger checkAutoAddMapping automatically.
          var cartDrawer = new theme.CartDrawer();
        })
        .catch(error => {
          console.error('Error adding item to cart:', error);
        });
      }
    });
  });
  function highlightCartItemsByMapping() {
    console.log("Here ??");
    const allCartItems = document.querySelectorAll('.cart__item');
  
    allCartItems.forEach(item => {
      const keyAttr = item.getAttribute('data-key');
      if (!keyAttr || !keyAttr.includes(':')) return;
  
      const variantId = keyAttr.split(':')[0]; // Extract variant ID from key
  
      for (const triggerVariantId in giftMappings) {
        const mapping = giftMappings[triggerVariantId];
        if (!mapping) continue;
  
        // If it's a trigger (main product)
        if (variantId === triggerVariantId) {
          item.setAttribute("data-item-type","gift-source");
          item.style.backgroundColor = 'rgba(255, 0, 0, 0.1)'; // Light red
          break;
        }
  
        // If it's a gift
        const isGift = mapping.products.some(prod => prod.targetVariantId === variantId);
        if (isGift) {
          item.setAttribute("data-item-type","gift");
          item.style.backgroundColor = 'rgba(0, 0, 255, 0.1)'; // Light blue
          break;
        }
      }
    });
  }
  
  document.addEventListener('cart:updated', function(e) {
    removeOrphanGiftItems();
  });
